/*
 * Copyright (c) 2024. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import DriversCountFilterItem from "pages/Front/Booking/components/BookingFilters/DriversCountFilterItem";
import {PersonType} from "types/enums/PersonType";
import React from "react";
import {useTranslation} from "react-i18next";
import {Package} from "types/entities/Package";
import {findPackageItemByPersonType, isAction, isEvent, isGiftCard, isGroupTypeChildren} from "utils/packageUtils";
import {PackageItemPersonType} from "types/enums/PackageItemPersonType";
import {BookingFilter} from "types/app";
import {UseFormSetValue} from "react-hook-form/dist/types";
import CardLabel from "pages/Front/Booking/components/BookingCustomer/CardLabel";
import {HallCode} from "types/enums/HallCode";
import {useTypedSelector} from "helpers/reducers";
import Loader from "components/Loader";

interface Props {
    showTitle: boolean;
    isMinimalistic: boolean;
    register: any;
    setValue: UseFormSetValue<BookingFilter>;
    watch: any;
    onChange: (type: string, value: string) => void;
    selectedPackage?: Package | null;
}

const DriversCountFilter = (props: Props) => {
    const {t} = useTranslation();
    const hall = useTypedSelector(state => state.hallState.hall);
    const adultsDisabled = props.selectedPackage && findPackageItemByPersonType(props.selectedPackage.packageItems, PackageItemPersonType.Adult);
    const childrenDisabled = props.selectedPackage && findPackageItemByPersonType(props.selectedPackage.packageItems, PackageItemPersonType.Child);
    const isPackageGiftCard = props.selectedPackage ? isGiftCard(props.selectedPackage) : false;
    const isPackageEvent = props.selectedPackage ? isEvent(props.selectedPackage) : false;
    // desighned for FamilyTickets
    const isPackageAction = props.selectedPackage ? isAction(props.selectedPackage) : false;
    const groupTypeChildren = props.selectedPackage ? isGroupTypeChildren(props.selectedPackage) : false;

    if (!hall) {
        return <Loader />;
    }

    return (
        <div className={"DriversCountFilter flex flex-col space-y-4 overflow-hidden"}>
            {props.showTitle && !isPackageEvent && (
                <div className={"DriversCountFilterItemTitle mb-2"}>
                    <CardLabel title={isPackageGiftCard ? t("Number of giftcards") : t("Number of people")} />
                </div>
            )}
            {props.selectedPackage ? (
                <div className={"BookingPackageSelected"}>
                    {/*{isPackageGiftCard && (*/}
                    {/*    <DriversCountFilterItem*/}
                    {/*        disabled={typeof adultsDisabled == "undefined" || adultsDisabled == null}*/}
                    {/*        isGiftCard={true}*/}
                    {/*        isMinimalistic={props.isMinimalistic}*/}
                    {/*        name="adults"*/}
                    {/*        personType={typeof adultsDisabled == "undefined" || adultsDisabled == null ? PersonType.Child : PersonType.Adult}*/}
                    {/*        register={props.register}*/}
                    {/*        selectedPackage={props.selectedPackage}*/}
                    {/*        setValue={props.setValue}*/}
                    {/*        watch={props.watch}*/}
                    {/*        onChange={props.onChange}*/}
                    {/*    />*/}
                    {/*)}*/}
                    {/*{isPackageEvent && !groupTypeChildren && (*/}
                    {/*    <DriversCountFilterItem*/}
                    {/*        disabled={typeof adultsDisabled == "undefined" || adultsDisabled == null}*/}
                    {/*        isEvent={true}*/}
                    {/*        isGroupTypeChildren={false}*/}
                    {/*        isMinimalistic={props.isMinimalistic}*/}
                    {/*        name="adults"*/}
                    {/*        personType={PersonType.Adult}*/}
                    {/*        register={props.register}*/}
                    {/*        selectedPackage={props.selectedPackage}*/}
                    {/*        setValue={props.setValue}*/}
                    {/*        watch={props.watch}*/}
                    {/*        onChange={props.onChange}*/}
                    {/*    />*/}
                    {/*)}*/}
                    {/*{isPackageEvent && groupTypeChildren && hall.hall_code !== HallCode.ArboPark && (*/}
                    {/*    <DriversCountFilterItem*/}
                    {/*        disabled={typeof childrenDisabled == "undefined" || childrenDisabled == null}*/}
                    {/*        isEvent={true}*/}
                    {/*        isGroupTypeChildren={true}*/}
                    {/*        isMinimalistic={props.isMinimalistic}*/}
                    {/*        name="children"*/}
                    {/*        personType={PersonType.Child}*/}
                    {/*        register={props.register}*/}
                    {/*        selectedPackage={props.selectedPackage}*/}
                    {/*        setValue={props.setValue}*/}
                    {/*        watch={props.watch}*/}
                    {/*        onChange={props.onChange}*/}
                    {/*    />*/}
                    {/*)}*/}
                    {/*{isPackageEvent && groupTypeChildren && (*/}
                    {/*    <DriversCountFilterItem*/}
                    {/*        disabled={typeof adultsDisabled == "undefined" || adultsDisabled == null}*/}
                    {/*        isEvent={true}*/}
                    {/*        isGroupTypeChildren={true}*/}
                    {/*        isMinimalistic={props.isMinimalistic}*/}
                    {/*        name="adults"*/}
                    {/*        personType={PersonType.Adult}*/}
                    {/*        register={props.register}*/}
                    {/*        selectedPackage={props.selectedPackage}*/}
                    {/*        setValue={props.setValue}*/}
                    {/*        watch={props.watch}*/}
                    {/*        onChange={props.onChange}*/}
                    {/*    />*/}
                    {/*)}*/}

                    {!isPackageGiftCard && !isPackageEvent && (
                        <DriversCountFilterItem
                            disabled={typeof adultsDisabled == "undefined" || adultsDisabled == null}
                            isAction={isPackageAction}
                            isMinimalistic={props.isMinimalistic}
                            name="adults"
                            personType={PersonType.Adult}
                            register={props.register}
                            selectedPackage={props.selectedPackage}
                            setValue={props.setValue}
                            watch={props.watch}
                            onChange={props.onChange}
                        />
                    )}
                    {/*{!isPackageGiftCard && !isPackageEvent && hall.hall_code !== HallCode.ArboPark && (*/}
                    {/*    <DriversCountFilterItem*/}
                    {/*        disabled={typeof childrenDisabled == "undefined" || childrenDisabled == null}*/}
                    {/*        isMinimalistic={props.isMinimalistic}*/}
                    {/*        name="children"*/}
                    {/*        personType={PersonType.Child}*/}
                    {/*        register={props.register}*/}
                    {/*        selectedPackage={props.selectedPackage}*/}
                    {/*        setValue={props.setValue}*/}
                    {/*        watch={props.watch}*/}
                    {/*        onChange={props.onChange}*/}
                    {/*    />*/}
                    {/*)}*/}
                    {(isPackageAction || (!isPackageGiftCard && !isPackageGiftCard)) && (
                        <DriversCountFilterItem
                            // disabled={typeof childrenDisabled == "undefined" || childrenDisabled == null}
                            isAction={isPackageAction}
                            isMinimalistic={props.isMinimalistic}
                            name="children"
                            personType={PersonType.Child}
                            register={props.register}
                            selectedPackage={props.selectedPackage}
                            setValue={props.setValue}
                            watch={props.watch}
                            onChange={props.onChange}
                        />
                    )}
                </div>
            ) : (
                <div className={"WithoutPackageSelected space-y-2"}>
                    <DriversCountFilterItem
                        isMinimalistic={props.isMinimalistic}
                        name="adults"
                        personType={PersonType.Adult}
                        register={props.register}
                        selectedPackage={props.selectedPackage}
                        setValue={props.setValue}
                        watch={props.watch}
                        onChange={props.onChange}
                    />
                    {(isPackageAction || (!isPackageGiftCard && !isPackageGiftCard)) && (
                        <DriversCountFilterItem
                            // disabled={typeof childrenDisabled == "undefined" || childrenDisabled == null}
                            isMinimalistic={props.isMinimalistic}
                            name="children"
                            personType={PersonType.Child}
                            register={props.register}
                            selectedPackage={props.selectedPackage}
                            setValue={props.setValue}
                            watch={props.watch}
                            onChange={props.onChange}
                        />
                    )}

                    {hall.hall_code !== HallCode.ArboPark && (
                        <DriversCountFilterItem
                            isMinimalistic={props.isMinimalistic}
                            name="children"
                            personType={PersonType.Child}
                            register={props.register}
                            selectedPackage={props.selectedPackage}
                            setValue={props.setValue}
                            watch={props.watch}
                            onChange={props.onChange}
                        />
                    )}
                </div>
            )}
        </div>
    );
};

export default DriversCountFilter;
